import { render, staticRenderFns } from "./BaseContent.vue?vue&type=template&id=5852afc0&scoped=true&lang=pug"
import script from "./BaseContent.vue?vue&type=script&lang=ts"
export * from "./BaseContent.vue?vue&type=script&lang=ts"
import style0 from "./BaseContent.vue?vue&type=style&index=0&id=5852afc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852afc0",
  null
  
)

export default component.exports